function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.366,
    height: 16.271,
    viewBox: "0 0 12.366 16.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-document"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 468",
    d: "M13.943 7.192V3.938H8.614a1.305 1.305 0 0 0-1.3 1.3v13.669a1.305 1.305 0 0 0 1.3 1.3h9.762a1.305 1.305 0 0 0 1.3-1.3V9.022h-3.9a1.833 1.833 0 0 1-1.833-1.83z",
    transform: "translate(-7.313 -3.938)",
    style: {
      fill: "#1573e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 467",
    d: "M21.427 8.431h3.952A.22.22 0 0 0 25.6 8.2a1.367 1.367 0 0 0-.465-1.039L21.818 4.28a1.359 1.359 0 0 0-.895-.336.328.328 0 0 0-.321.336v3.289a.844.844 0 0 0 .825.862z",
    transform: "translate(-13.231 -3.938)",
    style: {
      fill: "#1573e5"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.69b7a4283841ce19cb6b8d7ce11b5fa9.svg";
export { ForwardRef as ReactComponent };